"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ = require("../");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow: hidden;\n  position: relative;\n  background: ", ";\n  color: ", ";\n  border-radius: ", ";\n  max-height: ", ";\n  margin: ", ";\n  ", ";\n"])), function (p) {
  return p.isSuccess ? p.theme.colorAlertSuccessBackground : p.theme.colorAlertDangerBackground;
}, function (p) {
  return p.isSuccess ? p.theme.colorAlertSuccessText : p.theme.colorAlertDangerText;
}, function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.isVisible ? "200px" : "0";
}, function (p) {
  return p.isVisible ? "0 0 1rem" : "0";
}, function (p) {
  return p.isVisible !== undefined && "transition: max-height 0.325s";
});

var StyledMessage = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-family: ", ";\n\n  & > span,\n  & > div {\n    line-height: 1.5;\n  }\n\n  & > div::first-letter {\n    text-transform: uppercase;\n  }\n"])), function (p) {
  return p.theme.fontFamilyDefault;
});

var FormRowMessage = function FormRowMessage(_ref) {
  var margin = _ref.margin,
      children = _ref.children,
      isVisible = _ref.isVisible,
      isSuccess = _ref.isSuccess;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    margin: margin,
    isVisible: isVisible,
    isSuccess: isSuccess,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledMessage, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_.MatIcon, {
        margin: "0 0.5rem 0 0",
        children: "highlight_off"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        children: children
      })]
    })
  });
};

FormRowMessage.defaultp = {
  isSuccess: false
};
FormRowMessage.propTypes = {
  isVisible: _propTypes.default.bool,
  isSuccess: _propTypes.default.bool
};
var _default = FormRowMessage;
exports.default = _default;